export * as Api from './api';
export var TaxYearStatus;
(function (TaxYearStatus) {
    TaxYearStatus["NotApproved"] = "NOT_APPROVED";
    TaxYearStatus["Approved"] = "APPROVED";
})(TaxYearStatus || (TaxYearStatus = {}));
//# sourceMappingURL=index.js.map